import styled from 'styled-components';

export const WrapperLink = styled.a`
  & > * {
    text-decoration: none;
  }
`;

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  position: relative;
`;

export const MediaWrapper = styled.div`
  width: 100%;
  position: relative;

  img {
    border-radius: 12px;
  }
`;

export const Typology = styled.span`
  font-family: IntervalNextReg, sans-serif;
  font-weight: 100;
  line-height: normal;
  font-size: ${props => props.theme.rem(12)};
  line-height: ${props => props.theme.rem(15)};
  font-weight: 400;
  margin-top: ${props => props.theme.space(4)};
  padding-right: ${props => props.theme.space(3)};
  padding-left: ${props => props.theme.space(3)};
  color: ${props => props.theme.card.thirdColor};
`;

export const Title = styled.h2`
  font-family: IntervalNextReg, sans-serif;
  font-weight: 100;
  line-height: normal;
  font-size: ${props => props.theme.rem(18)};
  line-height: ${props => props.theme.rem(20)};
  font-weight: 600;
  color: ${props => props.theme.card.primaryTextColor};
  margin-bottom: ${props => props.theme.space(2)};
  padding-right: ${props => props.theme.space(3)};
  padding-left: ${props => props.theme.space(3)};
`;

export const Date = styled.p`
  font-family: IntervalNextReg, sans-serif;
  font-weight: 100;
  line-height: normal;
  font-size: ${props => props.theme.rem(14)};
  line-height: ${props => props.theme.rem(19)};
  font-weight: 400;
  color: ${props => props.theme.card.neighbourhoodIconColor};
  margin-bottom: ${props => props.theme.space(2)};
  padding-right: ${props => props.theme.space(3)};
  padding-left: ${props => props.theme.space(3)};
`;

export const Price = styled.p`
  font-family: IntervalNextReg, sans-serif;
  font-weight: 100;
  line-height: normal;
  font-size: ${props => props.theme.rem(14)};
  line-height: ${props => props.theme.rem(17)};
  font-weight: 400;
  color: ${props => props.theme.card.thirdColor};
  padding-right: ${props => props.theme.space(3)};
  padding-left: ${props => props.theme.space(3)};

  span {
    font-family: IntervalNextReg, sans-serif;
    font-size: ${props => props.theme.rem(22)};
    font-weight: 600;
    color: ${props => props.theme.card.primaryTextColor};
  }
`;

export const DescriptionWrapper = styled.div`
  padding-right: ${props => props.theme.space(1)};
  padding-left: ${props => props.theme.space(1)};
`;
